import { initTooltip } from '../directives/tooltip/tooltip.js';

const allTooltips = document.querySelectorAll('[data-tooltip-content]');

allTooltips.forEach((tooltip) => {
    initTooltip(tooltip, {
        content: tooltip.dataset.tooltipContent,
        shortcut: tooltip.dataset.tooltipShortcut ?? '',
    });
});

function updateTooltips() {
    const newTooltips = document.querySelectorAll(
        '[data-tooltip-content]:not([data-tooltip-init])'
    );
    newTooltips.forEach((tooltip) => {
        initTooltip(tooltip, {
            content: tooltip.dataset.tooltipContent,
            shortcut: tooltip.dataset.tooltipShortcut ?? '',
        });
    });
}

window.updateTooltips = updateTooltips;
